export interface GetAmbarVoyageListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAmbarVoyageListPagingAndFilterResponseData
}

export interface GetAmbarVoyageListPagingAndFilterResponseData {
    items: GetAmbarVoyageListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAmbarVoyageListPagingAndFilterResponseItem {
    ambarVoyageId: string
    companyId: string
    refNo: string
    vehicleId: string
    trailerId: string
    driverId: string
    supplierId: string
    isCustomActive: boolean
    vehicleName: string
    trailerName: string
    driverName: string
    supplierName: string
    ambars: GetAmbarVoyageListPagingAndFilterResponseAmbar[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAmbarVoyageListPagingAndFilterResponseAmbar {
    ambarId: string
    refNo: string
    customerId?: string
    customerName?: string
    deliverFirmCustomerId?: string
    deliverFirmCustomerName?: string
    deliverFirmCustomerAddressText?: string
    deliverFirmCustomerAddressLat?: number
    deliverFirmCustomerAddressLon?: number
    deliverCountyId?: string
    deliverCountyName?: string
    deliverDistrictId?: string
    deliverDistrictName?: string
    ambarVoyageOrder: number
}

export const initialGetAmbarVoyageListPagingAndFilterResponseData: GetAmbarVoyageListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}